module.exports = __webpack_public_path__ + "static/media/book.62481225.yaml";


//////////////////
// WEBPACK FOOTER
// ./src/content/book.yaml
// module id = 647
// module chunks = 0